import router from "../../router";
import leadService from "../../services/leadService";
import haugazelService from "../../services/haugazelService";
import { i18n } from "../../main.js";

const getDefaultState = () => {
  return {
    isUuid: false,
    params: {
      uuid: {
        key: 'uuid'
      },
      newSession: {
        key: 'newSession'
      },
      lang: {
        key: 'language'
      },
      promo: {
        key: 'promo'
      },
      agent: {
        key: 'agent'
      },
      agent_guid: {
        key: 'agentGuid'
      },
      agent_ref: {
        key: 'agentRef'
      },
      agent_ref_elec: {
        key: 'agentRefElec'
      },
      agent_ref_gas: {
        key: 'agentRefGas'
      },
      agent_jwt: {
        key: 'jwt'
      },
      campaign: {
        key: 'campaign'
      },
      step: {
        key: 'is2Step',
        type: 'boolean'
      },
      energy: {
        key: 'energy'
      },
      mono: {
        key: 'consumptionElecBase',
        type: 'integer'
      },
      low: {
        key: 'consumptionElecLow',
        type: 'integer'
      },
      high: {
        key: 'consumptionElecHigh',
        type: 'integer'
      },
      night: {
        key: 'consumptionElecNight',
        type: 'integer'
      },
      gas: {
        key: 'consumptionGas',
        type: 'integer'
      },
      solar_power: {
        key: 'solarPanelsPower',
        type: 'integer'
      },
      i_know: {
        key: 'knowConsumption',
        type: 'boolean'
      },
      empty: {
        key: 'emptyHouse',
        type: 'boolean'
      },
      people: {
        key: 'people',
        type: 'integer'
      },
      size: {
        key: 'houseSize',
        type: 'integer'
      },
      occupation: {
        key: 'occupation'
      },
      heating: {
        key: 'heating'
      },
      water: {
        key: 'water'
      },
      dryer: {
        key: 'dryer',
        type: 'boolean'
      },
      dishwasher: {
        key: 'dishwasher',
        type: 'boolean'
      },
      washing: {
        key: 'washingMachine',
        type: 'boolean'
      },
      electricCar: {
        key: 'electricCar',
        type: 'boolean'
      },
      battery: {
        key: 'battery',
        type: 'boolean'
      },
      city: {
        key: 'city',
      },
      area: {
        key: 'area',
      },
      zip: {
        key: 'zipCode',
      },
      provider_elec: {
        key: 'providerElec',
      },
      provider_gas: {
        key: 'providerGas',
      },
      civility: {
        key: 'civility',
      },
      firstname: {
        key: 'firstName',
      },
      lastname: {
        key: 'lastName',
      },
      phone: {
        key: 'phone',
      },
      email: {
        key: 'email',
      },
      type: {
        key: 'type',
      },
      agree: {
        key: 'optin',
        type: 'boolean'
      },
    },
    offers: [
      {
        id: 54,
        name: "Super",
        contractType: "variable",
        energy: "elec",
        idProduct: 900110,
        area: "all",
        duration: 1
      },
      {
        id: 55,
        name: "Super",
        contractType: "variable",
        energy: "gas",
        idProduct: 900246,
        area: "all",
        duration: 1
      },
      {
        id: 56,
        name: "Easy",
        contractType: "fixe",
        energy: "elec",
        idProduct: 900106,
        area: "all",
        duration: 1
      },
      {
        id: 57,
        name: "Easy",
        contractType: "fixe",
        energy: "elec",
        idProduct: 900106,
        area: "bx",
        duration: 1
      },
      {
        id: 58,
        name: "Easy",
        contractType: "variable",
        energy: "elec",
        idProduct: 900111,
        area: "all",
        duration: 1
      },
      {
        id: 59,
        name: "Easy",
        contractType: "variable",
        energy: "elec",
        idProduct: 900111,
        area: "bx",
        duration: 1
      },
      {
        id: 60,
        name: "Easy",
        contractType: "fixe",
        energy: "gas",
        idProduct: 900113,
        area: "all",
        duration: 1
      },
      {
        id: 61,
        name: "Easy",
        contractType: "fixe",
        energy: "gas",
        idProduct: 900113,
        area: "bx",
        duration: 1
      },
      {
        id: 62,
        name: "Easy",
        contractType: "variable",
        energy: "gas",
        idProduct: 900114,
        area: "all",
        duration: 1
      },
      {
        id: 63,
        name: "Easy",
        contractType: "variable",
        energy: "gas",
        idProduct: 900114,
        area: "bx",
        duration: 1
      },
      {
        id: 64,
        name: "Zen",
        contractType: "fixe",
        energy: "elec",
        idProduct: 900107,
        area: "all",
        duration: 3
      },
      {
        id: 65,
        name: "Zen",
        contractType: "fixe",
        energy: "elec",
        idProduct: 900107,
        area: "bx",
        duration: 3
      },
      {
        id: 66,
        name: "Zen",
        contractType: "fixe",
        energy: "elec",
        idProduct: 900107,
        area: "all",
        duration: 5
      },
      {
        id: 67,
        name: "Zen",
        contractType: "fixe",
        energy: "elec",
        idProduct: 900107,
        area: "bx",
        duration: 5
      },
      {
        id: 68,
        name: "Zen",
        contractType: "variable",
        energy: "gas",
        idProduct: 900115,
        area: "all",
        duration: 3
      },
      {
        id: 69,
        name: "Zen",
        contractType: "variable",
        energy: "gas",
        idProduct: 900115,
        area: "bx",
        duration: 3
      },
      {
        id: 70,
        name: "Zen",
        contractType: "variable",
        energy: "gas",
        idProduct: 900115,
        area: "all",
        duration: 5
      },
      {
        id: 71,
        name: "Zen",
        contractType: "variable",
        energy: "gas",
        idProduct: 900115,
        area: "bx",
        duration: 5
      },
      {
        id: 79,
        name: "Group",
        contractType: "variable",
        energy: "elec",
        idProduct: 900109,
        area: "all",
        duration: 1
      },
      {
        id: 80,
        name: "Group",
        contractType: "variable",
        energy: "gas",
        idProduct: 900245,
        area: "all",
        duration: 1
      },
      {
        id: 136,
        name: "Comfy",
        contractType: "",
        energy: "elec",
        idProduct: 900239,
        area: "all",
        duration: 1
      },
      {
        id: 137,
        name: "Comfy",
        contractType: "",
        energy: "gas",
        idProduct: 900240,
        area: "all",
        duration: 1
      },
      {
        id: 138,
        name: "Comfy",
        contractType: "",
        energy: "elec",
        idProduct: 900239,
        area: "bx",
        duration: 1
      },
      {
        id: 139,
        name: "Comfy",
        contractType: "",
        energy: "gas",
        idProduct: 900240,
        area: "bx",
        duration: 1
      }
    ],
    civilities: [
      {
        id: 20001,
        fr: "Madame",
        nl: "Mevrouw"
      },
      {
        id: 20003,
        fr: "Mademoiselle",
        nl: "Juffrouw"
      },
      {
        id: 20004,
        fr: "Monsieur et Madame",
        nl: "Meneer en Mevrouw"
      },
      {
        id: 20005,
        fr: "Monsieur",
        nl: "Meneer"
      },
      {
        id: 20006,
        fr: "Messieurs",
        nl: "Heren"
      },
      {
        id: 20007,
        fr: "Mesdames",
        nl: "Dames"
      }
    ]
  };
};

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    setIsUuid(state, value) {
      state.isUuid = value;
    },
    setOffers(state, value) {
      state.offers = value;
    },
    setForcedProducts(state, value) {
      state.forcedProducts = value;
    },
    setStateProperty(state, payload) {
      state[payload.param] = payload.value;
    },
    reset(state) {
      Object.keys(state).forEach(item => {
        delete state[item];
      });

      Object.assign(state, getDefaultState());
    }
  },
  actions: {
    async setLanguage(context, lang) {
      i18n.locale = lang;
      context.commit("common/setLang", lang, { root: true });
    },

    async setByUuid(context, uuid) {
      try {
        let lead = await leadService.get(uuid);

        Object.keys(lead).forEach(key => {
          context.commit("setStateProperty", {
            param: key,
            value: lead[key]
          });
        });

        if (lead.prospect) {
          Object.keys(lead.prospect).forEach(key => {
            context.commit("setStateProperty", {
              param: key,
              value: lead.prospect[key]
            });
          });
        }

        await context.dispatch("setState");
      } catch (error) {
        console.error(error);
        router.push({name: "Energy", query: {newSession: true}});
      }
    },

    async setGlobalState(context, params) {
      let parameters = {};
      for (let [key, value] of Object.entries(params)) {
        let param = Object.keys(context.state.params).find(item => item === key);
        // console.log(param);
        if (param !== undefined) {
          parameters[context.state.params[param].key] = value;
        }
      }
      console.log(parameters);

      Object.keys(parameters).forEach(param => {
        Object.values(context.state.params).forEach(key => {
          if (key.key === param) {
            if (key.hasOwnProperty('type') && key.type === 'integer') {
              context.commit("setStateProperty", {
                param: param,
                value: parseInt(parameters[param])
              });
            }
            if (key.hasOwnProperty('type') && key.type === 'boolean') {
              context.commit("setStateProperty", {
                param: param,
                value: parameters[param] !== 'false'
              });
            } else if (!key.hasOwnProperty('type')) {
              context.commit("setStateProperty", {
                param: param,
                value: parameters[param]
              });
            }
          }
        })
      });
      await context.dispatch("setState");
      console.log(context.state)
    },

    async setState(context) {
      if (context.state.uuid) {
        context.commit("common/setUuid", context.state.uuid, { root: true });
      } else {
        await context.dispatch("common/setUuid", {}, { root: true });
      }
      context.commit("common/setLang", context.state.language, { root: true });
      context.commit("common/setCustomerRef", context.state.customerRef, { root: true });
      context.commit("common/setCampaign", context.state.campaign, { root: true });
      i18n.locale = context.state.language || "fr";

      // energy
      if (context.state.energy) {
        context.commit("energy/setValid", true, {root: true});
        context.commit("energy/setType", context.state.energy, {root: true});
        await context.dispatch("energy/save", {}, {root: true});
      } else {
        context.commit("energy/setValid", true, {root: true});
        context.commit("energy/setType", 'both', {root: true});
        await context.dispatch("energy/save", {}, {root: true});

      }

        //consumptions
      if (
        (context.rootGetters["energy/hasElec"] &&
          (context.state.consumptionElecBase ||
            (context.state.consumptionElecLow &&
              context.state.consumptionElecHigh))) ||
        (context.rootGetters["energy/hasGas"] && context.state.consumptionGas)
      ) {
        let consumptions = [
          {
            meterType: "day",
            value: context.state.consumptionElecHigh
          },
          {
            meterType: "night",
            value: context.state.consumptionElecLow
          },
          {
            meterType: "mono",
            value: context.state.consumptionElecBase
          },
          {
            meterType: "exclusiveNight",
            value: context.state.consumptionElecNight
          },
          {
            meterType: "gas",
            value: context.state.consumptionGas
          }
        ];

        context.commit("consumption/setValid", true, {
          root: true
        });
        context.commit("consumption/setConsumptions", consumptions, {
          root: true
        });

        let meterTypes = [];
        consumptions.forEach(consumption => {
          if (consumption.value)
            meterTypes.push(consumption.meterType);
        });
        context.commit("consumption/setMeterType", meterTypes, {
          root: true
        });
      }
      context.commit(
        "consumption/setHasSolarPanels",
        context.state.solarPanelsPower !== undefined && context.state.solarPanelsPower,
        {
          root: true
        }
      );
      context.commit(
        "consumption/setSolarPanelsPower",
        context.state.solarPanelsPower,
        {
          root: true
        }
      );
      context.commit(
        "consumption/setSolarPanelsNumber",
        context.state.solarPanelsNumber,
        {
          root: true
        }
      );

      context.commit(
        "consumption/setKnowConsumption",
        context.state.knowConsumption,
        {
          root: true
        }
      );

      context.commit(
        "consumption/setDoubleFlow",
        context.state.doubleFlow,
        {
          root: true
        }
      );

      context.commit(
        "consumption/setHasSmartMeter",
        context.state.hasSmartMeter,
        {
          root: true
        }
      );

      context.commit(
        "consumption/setHasQuarterRegime",
        context.state.hasQuarterRegime,
        {
          root: true
        }
      );

      context.commit(
        "consumption/setKnowPeakLevel",
        context.state.knowPeakLevel,
        {
          root: true
        }
      );

      context.commit(
        "consumption/setPeakLevel",
        context.state.peakLevel,
        {
          root: true
        }
      );

      context.commit(
        "consumption/setKnowNetConsumption",
        context.state.knowNetConsumption,
        {
          root: true
        }
      );

      if (!context.state.knowConsumption) {
        if (context.state.emptyHouse) {
          context.commit("consumption/setEmptyHouse", context.state.emptyHouse, {
            root: true
          });
        }
        if (context.state.people) {
          context.commit("consumption/setPeople", context.state.people, {
            root: true
          });
        }
        if (context.state.houseSize) {
          context.commit("consumption/setHouseSize", context.state.houseSize, {
            root: true
          });
        }
        if (context.state.occupation) {
          context.commit("consumption/setOccupation", context.state.occupation, {
            root: true
          });
        }
        if (context.state.heating) {
          context.commit("consumption/setHeating", context.state.heating, {
            root: true
          });
        } else {
          if (context.rootGetters["energy/type"] === 'elec') {
            context.commit("consumption/setHeating", 'other', {
              root: true
            });
          } else {
            context.commit("consumption/setHeating", 'gas', {
              root: true
            });
          }
        }
        if (context.state.water) {
          context.commit("consumption/setWater", context.state.water, {
            root: true
          });
        } else {
          if (context.rootGetters["energy/type"] === 'elec') {
            context.commit("consumption/setWater", 'elec', {
              root: true
            });
          } else {
            context.commit("consumption/setWater", 'gas', {
              root: true
            });
          }
        }
        if (context.state.dryer) {
          context.commit("consumption/setDryer", context.state.dryer, {
            root: true
          });
        }
        if (context.state.dishwasher) {
          context.commit("consumption/setDishwasher", context.state.dishwasher, {
            root: true
          });
        }
        if (context.state.washingMachine) {
          context.commit("consumption/setWashingMachine", context.state.washingMachine, {
            root: true
          });
        }
        if (context.state.electricCar) {
          context.commit("consumption/setElectricCar", context.state.electricCar, {
            root: true
          });
        }
        if (context.state.battery) {
          context.commit("consumption/setBattery", context.state.battery, {
            root: true
          });
        }
        await context.commit("consumption/setValid", true, { root: true });
        await context.dispatch("consumption/getConsumption", {}, { root: true });
        let meterTypes = [];
        context.rootState.consumption.consumptions.forEach(consumption => {
          if (consumption.value !== null)
            meterTypes.push(consumption.meterType);
        });
        console.log(meterTypes)
        context.commit("consumption/setMeterType", meterTypes, {
          root: true
        });


      } else {
        context.commit(
          "consumption/setToDefault",
          {},
          {
            root: true
          }
        );
      }
      await context.dispatch("consumption/save", {}, { root: true });


      // calculation
      context.commit("calculation/setZipCode", context.state.zipCode, {
        root: true
      });

      if (context.state.zipCode) {
        context.commit("calculation/setValid", true, {
          root: true
        });

        context.commit("calculation/setCity", context.state.city, {
          root: true
        });

        context.commit("calculation/setArea", context.state.area, {
          root: true
        });

        context.commit(
          "calculation/setProviderElec",
          context.state.providerElec,
          {
            root: true
          }
        );
        context.commit(
          "calculation/setProviderGas",
          context.state.providerGas,
          {
            root: true
          }
        );

        context.commit("setIsUuid", true);
        await context.dispatch("calculation/getProviders", {}, { root: true });
      } else {
        context.commit("calculation/setValid", false, {
          root: true
        });
      }

      context.commit("calculation/setSimulation", context.state.simulation, {
        root: true
      });

      await context.dispatch("calculation/save", {}, { root: true });

      // contact
      context.commit(
        "contact/setIsPro",
        context.state.prospectType === "pro" ? true : false,
        {
          root: true
        }
      );
      context.commit("contact/setCivility", context.state.civility, {
        root: true
      });
      context.commit("contact/setFirstName", context.state.firstName, {
        root: true
      });
      context.commit("contact/setLastName", context.state.lastName, {
        root: true
      });
      context.commit("contact/setPhone", context.state.phone, {
        root: true
      });
      context.commit("contact/setMail", context.state.email, {
        root: true
      });
      context.commit("contact/setConsent", context.state.optin, {
        root: true
      });

      await context.dispatch("contact/save", {}, { root: true })

      if (!context.state.simulation) {
        if (context.state.comparisonResult) {
          let myElecProduct = context.state.comparisonResult.electricity
            ? context.state.comparisonResult.electricity.competitor.find(
              product => product.id === "myElec"
            )
            : null;

          context.commit("comparison/setMyElecProduct", myElecProduct, {
            root: true
          });

          let myGasProduct = context.state.comparisonResult.gas
            ? context.state.comparisonResult.gas.competitor.find(
              product => product.id === "myGas"
            )
            : null;

          context.commit("comparison/setMyGasProduct", myGasProduct, {
            root: true
          });
        }

        context.commit(
          "comparison/setCompetitorElecProduct",
          context.state.competitorProductElec,
          {
            root: true
          }
        );
        context.commit(
          "comparison/setCompetitorGasProduct",
          context.state.competitorProductGas,
          {
            root: true
          }
        );
      } else {
      }

      // console.log(context.rootState)
    },

    async setForcedProducts(context, params) {
      let forcedProducts = {}
      let energy = null;

      if(params['elec_product_id'] || params['gas_product_id']) {
        if(params['elec_product_id']) {
          let elecProduct = await haugazelService.getProduct(params['elec_product_id']);
          if(elecProduct) {
            forcedProducts['electricity'] = [elecProduct.hgzCode];
            energy = 'elec';
          }
        }

        if(params['gas_product_id']) {
          let gasProduct = await haugazelService.getProduct(params['gas_product_id']);
          if(gasProduct) {
            forcedProducts['gas'] = [gasProduct.hgzCode];
            energy = energy ? 'both' : 'gas';
          }
        }
      }
      // Offer useless in check
      // else if(params['elec_offer_id']) {
      //   let elecOffer = await haugazelService.getProductByOffer(params['elec_offer_id']);
      //   if(elecOffer && elecOffer.product && elecOffer.product.energy === 'electricity') {
      //     forcedProducts['electricity'] = [elecOffer.product.hgzId];
      //     energy = 'elec';

      //     if(elecOffer.pairedOffer) {
      //       if(params['gas_offer_id']) energy = 'both';
      //       forcedProducts['gas'] = [elecOffer.pairedOffer.product.hgzId];
      //     }
      //   }
      // }
      // else if(params['gas_offer_id']) {
      //   let gasOffer = await haugazelService.getProductByOffer(params['gas_offer_id']);
      //   if(gasOffer && gasOffer.product && gasOffer.product.energy === 'gas') {
      //     forcedProducts['gas'] = [gasOffer.product.hgzId];
      //     energy = 'gas';

      //     if(gasOffer.pairedOffer) {
      //       if(params['elec_offer_id']) energy = 'both';
      //       forcedProducts['electricity'] = [gasOffer.pairedOffer.product.hgzId];
      //     }
      //   }
      // }

      if(energy) {
        context.commit("energy/setType", energy, {root: true});
        context.commit("podium/setForcedProducts", forcedProducts, {root: true});
      }
    },

    async newSession(context) {
      console.log('new session')
      context.commit("reset");
      context.commit("common/reset", {}, { root: true });
      context.commit("energy/reset", {}, { root: true });
      context.commit("consumption/reset", {}, { root: true });
      context.commit("calculation/reset", {}, { root: true });
      context.commit("contact/reset", {}, { root: true });
      context.commit("podium/reset", {}, { root: true });
      context.commit("comparison/reset", {}, { root: true });
      context.commit("simulation/reset", {}, { root: true });
    }
  },
  getters: {
    become: (state, getters, rootState, rootGetters) => range => {
      let url = "https://become.mega.be?newSession";

      if (router.currentRoute.query["campaign"])
        url += `&campagne=${router.currentRoute.query["campaign"]}`;
      if (router.currentRoute.query["agent"])
        url += `&codeAgent=${router.currentRoute.query["agent"]}`;
      if (router.currentRoute.query["agent_ref"])
        url += `&refAgent=${router.currentRoute.query["agent_ref"]}`;
      if (router.currentRoute.query["agent_ref_elec"])
        url += `&refAgentElectricity=${
          router.currentRoute.query["agent_ref_elec"]
          }`;
      if (router.currentRoute.query["agent_ref_gas"])
        url += `&refAgentGas=${router.currentRoute.query["agent_ref_gas"]}`;
      if (router.currentRoute.query["promo"])
        url += `&codePromo=${router.currentRoute.query["promo"]}`;
      if (
        router.currentRoute.query["agent"] &&
        router.currentRoute.query["step"] !== undefined
      )
        url += `&9e3566e8b7d574d272703557d36700ac`;

      url += `&lang=${i18n.locale}`;
      url += `&electricite=${rootGetters["energy/hasElec"] ? 1 : 0}`;
      url += `&gaz=${rootGetters["energy/hasGas"] ? 1 : 0}`;
      url += `&travauxvide=${rootState.consumption.emptyHouse ? 1 : 0}`;
      url += `&cp=${rootState.calculation.zipCode}`;

      if (rootState.contact.lastName)
        url += `&nom=${rootState.contact.lastName}`;

      if (rootState.contact.firstName)
        url += `&prenom=${rootState.contact.firstName}`;

      if (rootState.contact.mail) url += `&email=${rootState.contact.mail}`;
      if (rootState.contact.phone) url += `&mobile=${rootState.contact.phone}`;
      if (rootState.contact.isPro) url += `&pro`;

      let civility = state.civilities.find(
        civility => civility[i18n.locale] === rootState.contact.civility
      );
      if (civility !== undefined) {
        url += `&civilite=${civility.id}`;
      }

      // let offers = state.offers;

      // if (rootState.calculation.area === "bx") {
      //   offers = offers.filter(offer => offer.area === "bx");
      // } else {
      //   offers = offers.filter(offer => offer.area !== "bx");
      // }

      if (range && !rootState.calculation.simulation) {
        if (rootState.calculation.providerElec)
          url += `&elec_fournisseur=${rootState.calculation.providerElec}`;

        if (rootState.calculation.providerGas)
          url += `&gaz_fournisseur=${rootState.calculation.providerGas}`;

        // if (range.gas) {
        //   let gasOffer = offers.find(
        //     offer =>
        //       offer.idProduct.toString() === range.gas.productId &&
        //       offer.duration === range.gas.duration
        //   );
        //   if (gasOffer !== undefined) url += `&gazOffre=${gasOffer.id}`;
        // }
      }

      if (range) {
        if (range.electricity && range.electricity.offerId) {
          url += `&elecOffre=${range.electricity.offerId}`;
        }

        if (range.gas && range.gas.offerId) {
          url += `&gazOffre=${range.gas.offerId}`;
        }
      }

      // if (range && rootState.calculation.simulation) {
      //   if (range.electricity) {
      //     let elecOffer = offers.find(
      //       offer =>
      //         offer.idProduct.toString() === range.electricity.productId &&
      //         offer.duration === range.electricity.duration
      //     );
      //     if (elecOffer !== undefined) url += `&elecOffre=${elecOffer.id}`;
      //   }

      //   if (range.gas) {
      //     let gasOffer = offers.find(
      //       offer =>
      //         offer.idProduct.toString() === range.gas.productId &&
      //         offer.duration === range.gas.duration
      //     );
      //     if (gasOffer !== undefined) url += `&gazOffre=${gasOffer.id}`;
      //   }
      // }

      return url;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/middleware.js